/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_HomeInputs */

const en_common_home = /** @type {(inputs: Common_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const es_common_home = /** @type {(inputs: Common_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Common_HomeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_home = /** @type {((inputs?: Common_HomeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_HomeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_home(inputs)
	return en_common_home(inputs)
});